// extracted by mini-css-extract-plugin
export default {"wrapper":"EmailVerificationModal_wrapper__bYINc"};